// extracted by mini-css-extract-plugin
module.exports = {"Layer":"📚4-7-0217rJ","BladeLayer":"📚4-7-0ANd1V","Translucent":"📚4-7-01siSs","disableScroll":"📚4-7-03Qb2T"};